import React, { useState } from 'react';
import sanitizer from '@helpers/sanitizer';
import { Breadcrumb } from '@interfaces/models/breadcrumb';
import { BreadcrumbList } from 'schema-dts';

type BreadcrumbSchemaProps = {
  breadcrumbs: Breadcrumb[];
} & React.HTMLProps<HTMLDivElement>;

const createBreadcrumbSchema = (breadcrumbs: Breadcrumb[]): BreadcrumbList => ({
  '@type': 'BreadcrumbList',
  itemListElement: breadcrumbs.map((breadcrumb: Breadcrumb, index: number) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: breadcrumb.localizedName,
      item: breadcrumb.url.url,
    };
  }),
});

const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = (props): React.JSX.Element => {
  const { breadcrumbs } = props;

  const [schema] = useState<BreadcrumbList>(createBreadcrumbSchema(breadcrumbs));

  return (
    <script
      data-cy="breadcrumbs-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: sanitizer(JSON.stringify(schema)),
      }}
    />
  );
};

export default BreadcrumbSchema;
